import { render, staticRenderFns } from "./BlankoComp.vue?vue&type=template&id=1b5b3a00&scoped=true&"
import script from "./BlankoComp.vue?vue&type=script&lang=ts&"
export * from "./BlankoComp.vue?vue&type=script&lang=ts&"
import style0 from "./BlankoComp.vue?vue&type=style&index=0&id=1b5b3a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b3a00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
